// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * LanguagesPanel — estilos del módulo de idiomas.
 * Todo con tokens del tema para que funcione con cualquier skin/paleta.
 */

.lang-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.lang-panel-loading {
  padding: 32px;
  text-align: center;
  color: var(--text-muted, rgba(226, 232, 240, 0.55));
}

.lang-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: wrap;
}

.lang-panel-title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
}

.lang-panel-subtitle {
  margin: 0;
  max-width: 72ch;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text-secondary, rgba(226, 232, 240, 0.68));
}

.lang-panel-provider {
  margin: 8px 0 0;
  font-size: 12px;
  color: var(--text-muted, rgba(226, 232, 240, 0.5));
}

.lang-panel-provider code {
  padding: 1px 5px;
  border-radius: 4px;
  background: var(--bg-input, rgba(255, 255, 255, 0.06));
  font-size: 11px;
}

.lang-alert {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  border: 1px solid transparent;
}

.lang-alert--error {
  color: #fecaca;
  background: rgba(220, 38, 38, 0.16);
  border-color: rgba(248, 113, 113, 0.35);
}

.lang-alert--ok {
  color: #bbf7d0;
  background: rgba(22, 163, 74, 0.14);
  border-color: rgba(74, 222, 128, 0.3);
}

.lang-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lang-card {
  padding: 14px 16px;
  border-radius: var(--radius-lg, 12px);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));
  background: var(--bg-card, rgba(255, 255, 255, 0.02));
}

.lang-card.is-disabled {
  opacity: 0.62;
}

.lang-card-head {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.lang-code {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #fff;
  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-2, #8b5cf6));
}

.lang-card-name {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.lang-card-name strong {
  font-size: 14px;
}

.lang-card-name span {
  font-size: 12px;
  color: var(--text-secondary, rgba(226, 232, 240, 0.6));
}

.lang-tag {
  margin-left: auto;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-secondary, rgba(226, 232, 240, 0.65));
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.14));
}

.lang-tag.is-builtin {
  color: var(--accent, #6366f1);
  border-color: color-mix(in srgb, var(--accent, #6366f1) 45%, transparent);
  background: color-mix(in srgb, var(--accent, #6366f1) 10%, transparent);
}

.lang-toggle {
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.16));
  background: transparent;
  color: var(--text-secondary, rgba(226, 232, 240, 0.65));
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.lang-toggle.is-on {
  color: #bbf7d0;
  border-color: rgba(74, 222, 128, 0.4);
  background: rgba(22, 163, 74, 0.15);
}

.lang-coverage {
  margin-top: 12px;
}

.lang-coverage-bar {
  height: 7px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--bg-input, rgba(255, 255, 255, 0.08));
}

.lang-coverage-bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--accent, #6366f1), var(--accent-2, #8b5cf6));
  transition: width 0.3s ease;
}

.lang-coverage-text {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 5px;
  font-size: 11px;
  color: var(--text-secondary, rgba(226, 232, 240, 0.6));
}

.lang-coverage-text strong {
  color: var(--text-primary, #e2e8f0);
  font-size: 12px;
}

.lang-card-meta {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 6px;
  font-size: 11px;
  color: var(--text-muted, rgba(226, 232, 240, 0.45));
}

.lang-card-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.lang-btn {
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.16));
  background: var(--bg-input, rgba(255, 255, 255, 0.04));
  color: var(--text-primary, #e2e8f0);
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.lang-btn:hover:not(:disabled) {
  border-color: color-mix(in srgb, var(--accent, #6366f1) 50%, transparent);
}

.lang-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lang-btn--primary {
  border-color: transparent;
  color: #fff;
  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-2, #8b5cf6));
}

.lang-btn--danger {
  color: #fca5a5;
  border-color: rgba(248, 113, 113, 0.35);
  background: rgba(220, 38, 38, 0.1);
}

.lang-progress {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  font-size: 11px;
  color: var(--text-secondary, rgba(226, 232, 240, 0.65));
}

.lang-progress.is-error {
  color: #fca5a5;
}

.lang-progress-bar {
  flex: 1 1;
  height: 6px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--bg-input, rgba(255, 255, 255, 0.08));
}

.lang-progress-bar span {
  display: block;
  height: 100%;
  background: var(--accent, #6366f1);
  transition: width 0.2s ease;
}

.lang-add {
  margin-top: 8px;
  padding: 16px;
  border-radius: var(--radius-lg, 12px);
  border: 1px dashed var(--border-color, rgba(255, 255, 255, 0.16));
  background: var(--bg-card, rgba(255, 255, 255, 0.02));
}

.lang-add-head h4 {
  margin: 0 0 4px;
  font-size: 14px;
}

.lang-add-head p {
  margin: 0 0 12px;
  font-size: 12px;
  color: var(--text-secondary, rgba(226, 232, 240, 0.6));
}

.lang-add-head code,
.lang-panel code {
  padding: 1px 4px;
  border-radius: 4px;
  background: var(--bg-input, rgba(255, 255, 255, 0.06));
}

.lang-add-fields {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.lang-input {
  min-width: 0;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.16));
  background: var(--bg-input, rgba(255, 255, 255, 0.04));
  color: var(--text-primary, #e2e8f0);
  font-size: 12px;
  font-family: inherit;
}

.lang-input:focus {
  outline: none;
  border-color: var(--accent, #6366f1);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent, #6366f1) 18%, transparent);
}

.lang-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-secondary, rgba(226, 232, 240, 0.7));
}

/* ── Modal de revisión ─────────────────────────────────────────────── */

.lang-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 21000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(3, 5, 10, 0.72);
  backdrop-filter: blur(8px);
}

.lang-modal {
  width: min(980px, 100%);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border-radius: var(--radius-xl, 16px);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.12));
  background: var(--bg-card, #0d0f1a);
  color: var(--text-primary, #e2e8f0);
  box-shadow: var(--shadow-xl, 0 24px 80px rgba(0, 0, 0, 0.5));
}

.lang-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.lang-modal-head h3 {
  margin: 4px 0 2px;
  font-size: 17px;
}

.lang-modal-head p {
  margin: 0;
  font-size: 12px;
  color: var(--text-secondary, rgba(226, 232, 240, 0.62));
}

.lang-modal-tools {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.lang-modal-tools .lang-input {
  flex: 1 1;
  min-width: 220px;
}

.lang-modal-count {
  font-size: 11px;
  color: var(--text-muted, rgba(226, 232, 240, 0.5));
}

.lang-modal-loading {
  padding: 24px;
  text-align: center;
  font-size: 13px;
  color: var(--text-muted, rgba(226, 232, 240, 0.55));
}

.lang-review-list {
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-right: 4px;
}

.lang-review-row {
  display: grid;
  grid-template-columns: minmax(180px, 260px) 1fr;
  gap: 10px;
  align-items: start;
  padding: 6px 0;
  border-bottom: 1px solid var(--border-color, rgba(255, 255, 255, 0.06));
}

.lang-review-key {
  font-size: 11px;
  color: var(--text-muted, rgba(226, 232, 240, 0.55));
  word-break: break-all;
  padding-top: 8px;
}

.lang-review-value {
  width: 100%;
  resize: vertical;
  line-height: 1.4;
}

@media (max-width: 700px) {
  .lang-review-row {
    grid-template-columns: 1fr;
  }

  .lang-review-key {
    padding-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LanguagesPanel.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,+DAA+D;EAC/D,qDAAqD;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uDAAuD;EACvD,gEAAgE;AAClE;;AAEA;EACE,6BAA6B;EAC7B,yEAAyE;EACzE,uEAAuE;AACzE;;AAEA;EACE,gEAAgE;EAChE,uBAAuB;EACvB,uDAAuD;EACvD,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,oFAAoF;EACpF,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;EACf,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;EAChE,sDAAsD;EACtD,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,qCAAqC;EACrC,iEAAiE;EACjE,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sDAAsD;AACxD;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gEAAgE;EAChE,sDAAsD;EACtD,mCAAmC;EACnC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,iFAAiF;AACnF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sDAAsD;AACxD;;AAEA,yEAAyE;;AAEzE;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,gEAAgE;EAChE,mCAAmC;EACnC,mCAAmC;EACnC,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,uEAAuE;AACzE;;AAEA;EACE,eAAe;EACf,mDAAmD;EACnD,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/**\r\n * LanguagesPanel — estilos del módulo de idiomas.\r\n * Todo con tokens del tema para que funcione con cualquier skin/paleta.\r\n */\r\n\r\n.lang-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.lang-panel-loading {\r\n  padding: 32px;\r\n  text-align: center;\r\n  color: var(--text-muted, rgba(226, 232, 240, 0.55));\r\n}\r\n\r\n.lang-panel-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 18px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.lang-panel-title {\r\n  margin: 0 0 4px;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n}\r\n\r\n.lang-panel-subtitle {\r\n  margin: 0;\r\n  max-width: 72ch;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.68));\r\n}\r\n\r\n.lang-panel-provider {\r\n  margin: 8px 0 0;\r\n  font-size: 12px;\r\n  color: var(--text-muted, rgba(226, 232, 240, 0.5));\r\n}\r\n\r\n.lang-panel-provider code {\r\n  padding: 1px 5px;\r\n  border-radius: 4px;\r\n  background: var(--bg-input, rgba(255, 255, 255, 0.06));\r\n  font-size: 11px;\r\n}\r\n\r\n.lang-alert {\r\n  padding: 10px 14px;\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.lang-alert--error {\r\n  color: #fecaca;\r\n  background: rgba(220, 38, 38, 0.16);\r\n  border-color: rgba(248, 113, 113, 0.35);\r\n}\r\n\r\n.lang-alert--ok {\r\n  color: #bbf7d0;\r\n  background: rgba(22, 163, 74, 0.14);\r\n  border-color: rgba(74, 222, 128, 0.3);\r\n}\r\n\r\n.lang-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.lang-card {\r\n  padding: 14px 16px;\r\n  border-radius: var(--radius-lg, 12px);\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));\r\n  background: var(--bg-card, rgba(255, 255, 255, 0.02));\r\n}\r\n\r\n.lang-card.is-disabled {\r\n  opacity: 0.62;\r\n}\r\n\r\n.lang-card-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.lang-code {\r\n  width: 42px;\r\n  height: 42px;\r\n  border-radius: 10px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  font-size: 12px;\r\n  font-weight: 800;\r\n  letter-spacing: 0.04em;\r\n  color: #fff;\r\n  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-2, #8b5cf6));\r\n}\r\n\r\n.lang-card-name {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  min-width: 0;\r\n}\r\n\r\n.lang-card-name strong {\r\n  font-size: 14px;\r\n}\r\n\r\n.lang-card-name span {\r\n  font-size: 12px;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.6));\r\n}\r\n\r\n.lang-tag {\r\n  margin-left: auto;\r\n  padding: 3px 9px;\r\n  border-radius: 999px;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.05em;\r\n  text-transform: uppercase;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.65));\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.14));\r\n}\r\n\r\n.lang-tag.is-builtin {\r\n  color: var(--accent, #6366f1);\r\n  border-color: color-mix(in srgb, var(--accent, #6366f1) 45%, transparent);\r\n  background: color-mix(in srgb, var(--accent, #6366f1) 10%, transparent);\r\n}\r\n\r\n.lang-toggle {\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.16));\r\n  background: transparent;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.65));\r\n  border-radius: 999px;\r\n  padding: 4px 10px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n\r\n.lang-toggle.is-on {\r\n  color: #bbf7d0;\r\n  border-color: rgba(74, 222, 128, 0.4);\r\n  background: rgba(22, 163, 74, 0.15);\r\n}\r\n\r\n.lang-coverage {\r\n  margin-top: 12px;\r\n}\r\n\r\n.lang-coverage-bar {\r\n  height: 7px;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  background: var(--bg-input, rgba(255, 255, 255, 0.08));\r\n}\r\n\r\n.lang-coverage-bar span {\r\n  display: block;\r\n  height: 100%;\r\n  border-radius: inherit;\r\n  background: linear-gradient(90deg, var(--accent, #6366f1), var(--accent-2, #8b5cf6));\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.lang-coverage-text {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n  margin-top: 5px;\r\n  font-size: 11px;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.6));\r\n}\r\n\r\n.lang-coverage-text strong {\r\n  color: var(--text-primary, #e2e8f0);\r\n  font-size: 12px;\r\n}\r\n\r\n.lang-card-meta {\r\n  display: flex;\r\n  gap: 14px;\r\n  flex-wrap: wrap;\r\n  margin-top: 6px;\r\n  font-size: 11px;\r\n  color: var(--text-muted, rgba(226, 232, 240, 0.45));\r\n}\r\n\r\n.lang-card-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  margin-top: 12px;\r\n}\r\n\r\n.lang-btn {\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.16));\r\n  background: var(--bg-input, rgba(255, 255, 255, 0.04));\r\n  color: var(--text-primary, #e2e8f0);\r\n  border-radius: 8px;\r\n  padding: 7px 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s ease, background 0.15s ease;\r\n}\r\n\r\n.lang-btn:hover:not(:disabled) {\r\n  border-color: color-mix(in srgb, var(--accent, #6366f1) 50%, transparent);\r\n}\r\n\r\n.lang-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.lang-btn--primary {\r\n  border-color: transparent;\r\n  color: #fff;\r\n  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-2, #8b5cf6));\r\n}\r\n\r\n.lang-btn--danger {\r\n  color: #fca5a5;\r\n  border-color: rgba(248, 113, 113, 0.35);\r\n  background: rgba(220, 38, 38, 0.1);\r\n}\r\n\r\n.lang-progress {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 10px;\r\n  font-size: 11px;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.65));\r\n}\r\n\r\n.lang-progress.is-error {\r\n  color: #fca5a5;\r\n}\r\n\r\n.lang-progress-bar {\r\n  flex: 1;\r\n  height: 6px;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  background: var(--bg-input, rgba(255, 255, 255, 0.08));\r\n}\r\n\r\n.lang-progress-bar span {\r\n  display: block;\r\n  height: 100%;\r\n  background: var(--accent, #6366f1);\r\n  transition: width 0.2s ease;\r\n}\r\n\r\n.lang-add {\r\n  margin-top: 8px;\r\n  padding: 16px;\r\n  border-radius: var(--radius-lg, 12px);\r\n  border: 1px dashed var(--border-color, rgba(255, 255, 255, 0.16));\r\n  background: var(--bg-card, rgba(255, 255, 255, 0.02));\r\n}\r\n\r\n.lang-add-head h4 {\r\n  margin: 0 0 4px;\r\n  font-size: 14px;\r\n}\r\n\r\n.lang-add-head p {\r\n  margin: 0 0 12px;\r\n  font-size: 12px;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.6));\r\n}\r\n\r\n.lang-add-head code,\r\n.lang-panel code {\r\n  padding: 1px 4px;\r\n  border-radius: 4px;\r\n  background: var(--bg-input, rgba(255, 255, 255, 0.06));\r\n}\r\n\r\n.lang-add-fields {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n\r\n.lang-input {\r\n  min-width: 0;\r\n  padding: 8px 10px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.16));\r\n  background: var(--bg-input, rgba(255, 255, 255, 0.04));\r\n  color: var(--text-primary, #e2e8f0);\r\n  font-size: 12px;\r\n  font-family: inherit;\r\n}\r\n\r\n.lang-input:focus {\r\n  outline: none;\r\n  border-color: var(--accent, #6366f1);\r\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent, #6366f1) 18%, transparent);\r\n}\r\n\r\n.lang-check {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.7));\r\n}\r\n\r\n/* ── Modal de revisión ─────────────────────────────────────────────── */\r\n\r\n.lang-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 21000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  background: rgba(3, 5, 10, 0.72);\r\n  backdrop-filter: blur(8px);\r\n}\r\n\r\n.lang-modal {\r\n  width: min(980px, 100%);\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding: 20px;\r\n  border-radius: var(--radius-xl, 16px);\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.12));\r\n  background: var(--bg-card, #0d0f1a);\r\n  color: var(--text-primary, #e2e8f0);\r\n  box-shadow: var(--shadow-xl, 0 24px 80px rgba(0, 0, 0, 0.5));\r\n}\r\n\r\n.lang-modal-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n}\r\n\r\n.lang-modal-head h3 {\r\n  margin: 4px 0 2px;\r\n  font-size: 17px;\r\n}\r\n\r\n.lang-modal-head p {\r\n  margin: 0;\r\n  font-size: 12px;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.62));\r\n}\r\n\r\n.lang-modal-tools {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.lang-modal-tools .lang-input {\r\n  flex: 1;\r\n  min-width: 220px;\r\n}\r\n\r\n.lang-modal-count {\r\n  font-size: 11px;\r\n  color: var(--text-muted, rgba(226, 232, 240, 0.5));\r\n}\r\n\r\n.lang-modal-loading {\r\n  padding: 24px;\r\n  text-align: center;\r\n  font-size: 13px;\r\n  color: var(--text-muted, rgba(226, 232, 240, 0.55));\r\n}\r\n\r\n.lang-review-list {\r\n  overflow: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding-right: 4px;\r\n}\r\n\r\n.lang-review-row {\r\n  display: grid;\r\n  grid-template-columns: minmax(180px, 260px) 1fr;\r\n  gap: 10px;\r\n  align-items: start;\r\n  padding: 6px 0;\r\n  border-bottom: 1px solid var(--border-color, rgba(255, 255, 255, 0.06));\r\n}\r\n\r\n.lang-review-key {\r\n  font-size: 11px;\r\n  color: var(--text-muted, rgba(226, 232, 240, 0.55));\r\n  word-break: break-all;\r\n  padding-top: 8px;\r\n}\r\n\r\n.lang-review-value {\r\n  width: 100%;\r\n  resize: vertical;\r\n  line-height: 1.4;\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  .lang-review-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .lang-review-key {\r\n    padding-top: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
